"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _LinkedInNavigatorActions = require("crm_data/linkedin/LinkedInNavigatorActions");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIDialogButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogButton"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UIColumn = _interopRequireDefault(require("UIComponents/column/UIColumn"));

var _UIColumnSpreads = _interopRequireDefault(require("UIComponents/column/UIColumnSpreads"));

var _UIColumnWrapper = _interopRequireDefault(require("UIComponents/column/UIColumnWrapper"));

var _LinkedInSalesNavigatorIframe = _interopRequireDefault(require("./LinkedInSalesNavigatorIframe"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    height: ", ";\n    flex-grow: 1;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    width: ", ";\n    overflow: ", ";\n    margin-bottom: 0;\n    box-shadow: 0 1px 24px 0 rgba(0, 0, 0, 0.08);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var propTypes = {
  objectType: _ProfileObjectTypesType.default.isRequired,
  subject: _SubjectType.default.isRequired,
  subjectId: _propTypes.default.string.isRequired,
  isMinimized: _propTypes.default.bool.isRequired
};
var LinkedInNavigator = (0, _styledComponents.default)(_UICardWrapper.default).withConfig({
  displayName: "LinkedInSalesNavigatorInMail__LinkedInNavigator",
  componentId: "qxvlp8-0"
})(_templateObject(), function (_ref) {
  var isMinimized = _ref.isMinimized;
  return isMinimized ? '300px' : '580px';
}, function (_ref2) {
  var isMinimized = _ref2.isMinimized;
  return isMinimized ? 'hidden' : 'auto';
});

var LinkedInNavigatorBody = _styledComponents.default.div.withConfig({
  displayName: "LinkedInSalesNavigatorInMail__LinkedInNavigatorBody",
  componentId: "qxvlp8-1"
})(_templateObject2(), function (_ref3) {
  var isMinimized = _ref3.isMinimized;
  return isMinimized ? 0 : '100%';
});

var LinkedInSalesNavigatorInMail =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(LinkedInSalesNavigatorInMail, _PureComponent);

  function LinkedInSalesNavigatorInMail() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, LinkedInSalesNavigatorInMail);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(LinkedInSalesNavigatorInMail)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.toggleLinkedInNavigator = function () {
      if (_this.props.isMinimized) {
        (0, _LinkedInNavigatorActions.maximizeLinkedInNavigator)();
      } else {
        (0, _LinkedInNavigatorActions.minimizeLinkedInNavigator)();
      }
    };

    return _this;
  }

  (0, _createClass2.default)(LinkedInSalesNavigatorInMail, [{
    key: "renderBody",
    value: function renderBody() {
      var _this$props = this.props,
          objectType = _this$props.objectType,
          subject = _this$props.subject,
          subjectId = _this$props.subjectId,
          isMinimized = _this$props.isMinimized;
      return _react.default.createElement(LinkedInNavigatorBody, {
        className: "overflow-auto",
        isMinimized: isMinimized
      }, _react.default.createElement(_LinkedInSalesNavigatorIframe.default, {
        key: subjectId,
        objectType: objectType,
        modules: ['Messaging'],
        subjectId: subjectId,
        subject: subject,
        height: 500
      }));
    }
  }, {
    key: "renderCloseButton",
    value: function renderCloseButton() {
      return _react.default.createElement(_UIDialogButton.default, {
        "aria-label": "Minimize dialog",
        className: "m-x-2",
        onClick: _LinkedInNavigatorActions.hideLinkedInNavigator,
        iconName: "remove"
      });
    }
  }, {
    key: "renderMinimizeToggle",
    value: function renderMinimizeToggle() {
      return _react.default.createElement(_UIDialogButton.default, {
        "aria-label": "Minimize dialog",
        className: "m-x-2",
        onClick: this.toggleLinkedInNavigator,
        iconName: "minus"
      });
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      return _react.default.createElement(_UIColumn.default, null, this.renderMinimizeToggle(), this.renderCloseButton());
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      return _react.default.createElement(_UIColumnSpreads.default, null, _react.default.createElement("div", {
        onClick: this.toggleLinkedInNavigator,
        className: "pointer"
      }, _react.default.createElement("h5", {
        className: "m-all-0 p-all-0"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "profileSidebarModule.linkedInSalesNavigator.inMailTitle"
      }))));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      return _react.default.createElement(_UIDialogHeader.default, {
        className: (0, _classnames.default)('communicator-header', 'p-x-5')
      }, _react.default.createElement(_UIColumnWrapper.default, {
        align: "center"
      }, this.renderTitle(), this.renderActions()));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(LinkedInNavigator, {
        className: "p-x-0 p-bottom-0 display-flex",
        isMinimized: this.props.isMinimized
      }, this.renderHeader(), this.renderBody());
    }
  }]);
  return LinkedInSalesNavigatorInMail;
}(_PureComponent2.default);

LinkedInSalesNavigatorInMail.propTypes = propTypes;
var _default = LinkedInSalesNavigatorInMail;
exports.default = _default;
module.exports = exports.default;